export const TOKEN = "token";
export const CUSTOMER_INFO = "customer info";
export const CARTID = "cartId";
